import { createContext, useContext } from "react"
import { type CurrencyConfig, type CurrencyCode } from "@/lib/currency-data.ts"

export interface FormatOptions {
	compact?: boolean
	skipConversion?: boolean
	fromCurrency?: string
	noDecimals?: boolean
}

export interface LocalFormatOptions {
	compact?: boolean
	noDecimals?: boolean
}

export interface CurrencyContextType {
	currency: CurrencyConfig
	setCurrency: (code: CurrencyCode) => void
	convert: (amount: number, fromCurrency?: string) => number
	format: (amount: number, options?: FormatOptions) => string
	localFormat: (amount: number, localCurrency?: string, options?: LocalFormatOptions) => string
}

// 1. Create the Context here
export const CurrencyContext = createContext<CurrencyContextType | undefined>(undefined)

// 2. Export the Hook here
export function useCurrency() {
	const context = useContext(CurrencyContext)
	if (!context) throw new Error("useCurrency must be used within a CurrencyProvider")
	return context
}
